let changeInterval = 9000;
let items: NodeListOf<Element>;
let intervalTimer: any;
let currentScreenIdx = 0;

export const slider = {
  init: (sliderItems: NodeListOf<Element>, startIdx: number, interval: number) => {
    items = sliderItems;
    changeInterval = interval;

    const leftControl = document.querySelector(".slide-control.left");
    const rightControl = document.querySelector(".slide-control.right");
    if (!leftControl || !rightControl) {
      return;
    }

    leftControl.addEventListener("click", () => {
      slider.clickPrevious();
    });

    rightControl.addEventListener("click", () => {
      slider.clickNext();
    });

    intervalTimer = setupChangeTimer();

    currentScreenIdx = startIdx;
    items[currentScreenIdx].classList.add("active");
  },
  clickNext: () => {
    clearInterval(intervalTimer);
    slider.nextSlide();
    intervalTimer = setupChangeTimer();
  },
  clickPrevious: () => {
    clearInterval(intervalTimer);
    slider.previousSlide();
    intervalTimer = setupChangeTimer();
  },
  previousSlide: () => {
    slider.reset();
    if (currentScreenIdx === 0) {
      currentScreenIdx = items.length - 1;
    } else {
      currentScreenIdx--;
    }
    items[currentScreenIdx].classList.add("active");
  },
  nextSlide: () => {
    slider.reset();
    if (currentScreenIdx === items.length - 1) {
      currentScreenIdx = 0;
    } else {
      currentScreenIdx++;
    }
    items[currentScreenIdx].classList.add("active");
  },
  reset: () => {
    items.forEach((item) => item.classList.remove("active"));
  },
};

function setupChangeTimer() {
  return setInterval(slider.nextSlide, changeInterval);
}
